import React, { Fragment, useEffect, useState } from "react";
import styled from "styled-components";
import edit from "../assets/edit-text.svg";
import save from "../assets/diskette (2).png";
import PdfViewer from "../PdfFolder/pdf";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl } from "../../../../Constnats/constants";
import { useNavigate } from "react-router-dom";
function EditViewPage({
  data,
  organizationType,
  stateList,
  realCaptcha,
  selectedFile,
  pdfData,
  setSelectedFile,
  setPdfData,
  setIsSubmitted,
  isSubmitted,
  uid,
  reset,
  setUploadStatus,
  setShowOtherField,
  setShowOtherAgency,
  setshowNicFields,
}) {
  const agency = [
    {
      text: "In Choice",
      value: "I",
    },
    {
      text: "NIC",
      value: "N",
    },
    {
      text: "Others",
      value: "O",
    },
  ];
  const [editDetails, setEditDetails] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState(data);
  const [latestUpload, setLatestUpload] = useState(null);
  const [isUploadClick, setIsUploadClick] = useState(false);
  const [fileuploadStatus, setFileUploadStatus] = useState("");
  const [fileuploadErrorStatus, setFileUploadErrorStatus] = useState("");
  const [showOtherFieldEdit, setShowOtherFieldEdit] = useState(
    data.orgtype === "Others"
  );
  const [showOtherAgencyEdit, setShowOtherAgencyEdit] = useState(
    data.agencyType === "O"
  );

  const [showNICDetails, setShowNICDetails] = useState(data.agencyType === "N");
  console.log(selectedFile, "selectedFileselectedFile");
  const handleEditClick = () => {
    setEditDetails(true);
  };
  console.log(isUploadClick, latestUpload, "latesttt");

  const getOrgTypeState = (param, opt) => {
    let type = "";

    switch (opt) {
      case "orgtype":
        organizationType.forEach((orgType) => {
          if (orgType.id == param) type = orgType.type;
        });
        break;
      case "state":
        stateList.forEach((state) => {
          if (state.stateCode == param) type = state.stateName;
        });
        break;
    }
    return type;
  };
  const handleSaveClick = async (e) => {
    // debugger
    // e.preventDefault();
    if (validateForm()) {
      console.log("Validation success");
      if (latestUpload && !isUploadClick) {
        toast.error("File is selected. Please click the  upload button.");
        setFileUploadStatus("");
        setFileUploadErrorStatus(
          "File is selected. Please click the upload  button."
        );
      } else {
        const renamedFile = new File([selectedFile], `${uid}.pdf`, {
          type: selectedFile.type,
        });
        const fileformData = new FormData();
        fileformData.append("file", renamedFile);
        fileformData.append("name", "Test Name");
        fileformData.append("desc", "Test description");
        console.log(fileformData, "fileformDatafileformData");
        try {
          const response = await fetch(`${baseUrl}/upload`, {
            method: "POST",
            body: fileformData,
          });

          if (response.ok) {
            setFileUploadStatus("Uploaded the file successfully");

            // Second API call after successful file upload

            try {
              const secondResponse = await fetch(`${baseUrl}/postrequest`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  ...formData,
                  uid,
                  fileName: renamedFile.name,
                }),
              });

              if (secondResponse.ok) {
                toast.success(
                  "Registration for NICDSign Successfully completed. Thank you!"
                );
                setSelectedFile(latestUpload);
                setFileUploadStatus("");
                setLatestUpload(null);
                setEditDetails(false);
                setIsSubmitted(false);
                setShowOtherField(false);
                setShowOtherAgency(false);
                setshowNicFields(false);
                reset();
                setUploadStatus("");

                setTimeout(() => {
                  navigate("/");
                }, 5000);
              } else {
                const errorJson = await secondResponse.text();
                console.error("Error in second API call:", errorJson);
                toast.error(errorJson);
              }
            } catch (error) {
              console.error("Error in second API call:", error);
              toast.error(error);
            }
          } else {
            const err = await response.json();
            toast.error(
              err.message.includes("Maximum")
                ? "Maximum PDF file size is 500 KB"
                : err.message
            );
            setFileUploadStatus("");
            setFileUploadErrorStatus(
              err.message.includes("Maximum")
                ? "Maximum PDF file size is 500 KB"
                : err.message
            );
          }
        } catch (error) {
          console.error("Error: ", error);
          setFileUploadStatus("");
          setFileUploadErrorStatus("Failed to upload file");
        }
      }
    } else {
      // Handle validation errors
      console.log("Validation failed");
    }
  };

  const handleCancelClick = (section) => {
    setEditDetails(false);
    setFormData(data);
    setSelectedFile(selectedFile);
    setFileUploadStatus("");
    setFileUploadErrorStatus("");
    setIsUploadClick(false);
    setLatestUpload(null);
    setShowOtherFieldEdit(data.orgtype === "5");
  };
  const handleChange = (e) => {
    const { id, value } = e.target;
    let newFormData = { ...formData, [id]: value };

    if (id === "orgtype" && value === "5") {
      setShowOtherFieldEdit(true);
    } else if (id === "orgtype") {
      setShowOtherFieldEdit(false);
      delete newFormData.othertype; // Remove otherType if orgType is not Others
    }

    setFormData(newFormData);
  };

  const handleChangeAgency = (e) => {
    const { id, value } = e.target;
    let newFormData = { ...formData, [id]: value };

    if (value === "O") {
      setShowOtherAgencyEdit(true);
      setShowNICDetails(false);
      delete newFormData.niccontactname;
      delete newFormData.niccontactno;
      delete newFormData.niccontactemail;
      delete newFormData.niccontactdesg;
    } else if (value === "N") {
      setShowOtherAgencyEdit(false);
      setShowNICDetails(true);
      delete newFormData.otheragency;
    } else if (value === "I") {
      setShowOtherAgencyEdit(false);
      setShowNICDetails(false);
      delete newFormData.otheragency;
      delete newFormData.niccontactname;
      delete newFormData.niccontactno;
      delete newFormData.niccontactemail;
      delete newFormData.niccontactdesg;
    }

    setFormData(newFormData);
  };
  const handleLatestUploadFile = (e) => {
    const file = e.target.files[0];
    setLatestUpload(file);
    const reader = new FileReader();
    reader.onload = (e) => {
      setPdfData(e.target.result);
    };
    reader.readAsDataURL(file);
    setIsUploadClick(false);
    setFileUploadStatus("");
    setFileUploadErrorStatus("");
  };
  const handleUploadLatestFileSubmission = async (e) => {
    e.preventDefault();
    if (latestUpload) {
      setIsUploadClick(true);
      setFileUploadStatus("Uploaded the file successfully");
      setFileUploadErrorStatus("");
      setSelectedFile(latestUpload);
    } else {
    }
  };

  // const scrollToTop = () => {
  //   const element = document.getElementById("detailMainWrapper");
  //   if (element) {
  //     element.scrollIntoView({ behavior: "smooth", block: "start" });
  //   }
  // };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [errors, setErrors] = useState({});
  const validateForm = () => {
    const newErrors = {};
    // if (!formData.othertype)
    //   newErrors.othertype = "If Others (specify) is required.*";
    if (!formData.orgname)
      newErrors.orgname = "Organization Name is required.*";
    if (!formData.orgaddress)
      newErrors.orgaddress = "Organization Address is required.*";
    if (!formData.state) newErrors.state = "State is required.* ";
    if (!formData.deptname) newErrors.deptname = "Department is required.*";
    if (!formData.orghead)
      newErrors.orghead = "Head of Organization is required.*";
    if (!formData.phoneno) {
      newErrors.phoneno = "Phone Number is required.*";
    } else if (!/^\d{8,12}$/.test(formData.phoneno)) {
      newErrors.phoneno =
        "Phone Number must be minimum 8 digits ,maximum 12 digits.*";
    }
    if (!formData.projectname)
      newErrors.projectname = "Project Name is required.*";
    if (!formData.projectdesc)
      newErrors.projectdesc = "Project Description is required.*";
    if (!formData.nodalofficer)
      newErrors.nodalofficer = "Nodal Officer Name is required.*";
    if (!formData.nodaldesignation)
      newErrors.nodaldesignation = "Nodal Officer Designation is required.*";
    if (!formData.mobileno) {
      newErrors.mobileno = "Contact Number is required.*";
    } else if (!/^\d{8,12}$/.test(formData.mobileno)) {
      newErrors.mobileno =
        "Contact Number must be minimum 8 digits,maximum 12 digits.*";
    }
    if (!formData.email) {
      newErrors.email = "Email is required.*";
    } else if (
      !formData.email ||
      !formData.email.includes("@") ||
      !(
        formData.email.toLowerCase().endsWith("nic.in") ||
        formData.email.toLowerCase().endsWith("gov.in")
      )
    ) {
      newErrors.email =
        "Invalid email address. Only 'gov.in' and 'nic.in' domains are allowed.*";
    }
    if (!formData.agencyType) {
      newErrors.agencyType = "Agency Type is required.*";
    } else {
      if (formData.agencyType == "O" && !formData.otheragency)
        newErrors.agencyType = "Other Agency Name is required.*";

      if (formData.agencyType == "N") {
        if (!formData.niccontactno) {
          newErrors.mobileno = "Contact Number is required.*";
        } else if (!/^\d{8,12}$/.test(formData.niccontactno)) {
          newErrors.niccontactno =
            "Contact Number must be minimum 8 digits,maximum 12 digits.*";
        }
        if (!formData.niccontactemail) {
          newErrors.niccontactemail = "Email is required.*";
        } else if (
          !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(gov\.in|nic\.in)$/i.test(
            formData.niccontactemail
          )
        ) {
          newErrors.niccontactemail =
            "Invalid email address. Only 'gov.in' and 'nic.in' domains are allowed.*";
        }

        if (!formData.niccontactdesg)
          newErrors.niccontactdesg = "Designation is required.*";
      }
    }
    setErrors(newErrors);

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };
  console.log(formData, "formDataformData");

  return (
    <Fragment>
      <MainWrapper>
        <div className="row d-flex justify-content-center">
          <div class={editDetails ? "col-md-8" : "col-md-7 "}>
            {editDetails ? (
              <div className="editSave " style={{ paddingBottom: "10px" }}>
                <MainHeader>Update Your Details</MainHeader>
                <div className="editInnerWrap">
                  <SaveBtn onClick={() => handleSaveClick()}>
                    Submit Request
                    <img src={save} alt="save" style={{ width: "13px" }} />
                  </SaveBtn>
                  <CancelBtn onClick={() => handleCancelClick()}>
                    Cancel
                  </CancelBtn>
                </div>
              </div>
            ) : (
              <div className="editSave">
                <MainHeader>Request for NICDSign</MainHeader>
                <div className="editInnerWrap">
                  <SaveBtn onClick={() => handleSaveClick()}>
                    Submit Request
                    <img src={save} alt="save" style={{ width: "13px" }} />
                  </SaveBtn>
                  <EditBtn onClick={() => handleEditClick()}>
                    Edit
                    <img src={edit} alt="edit" />
                  </EditBtn>
                </div>
              </div>
            )}
            {editDetails ? (
              <>
                {/* <form className="form-body" onSubmit={handleFormSubmit}> */}
                <CardWrapper className={editDetails ? "boxDesgn" : "boxDesgn1"}>
                  <div className="firstSection">
                    <div className="headerWrap ">
                      <MainHeader>Organization details</MainHeader>
                    </div>
                    <div className="contentWrap">
                      <form className="form-body">
                        <div
                          className={
                            showOtherFieldEdit ? "section1" : "section2"
                          }
                        >
                          <div>
                            <div
                              className={
                                editDetails
                                  ? "form-group addStyle2 "
                                  : "form-group addStyle"
                              }
                            >
                              <label className="form__labels" htmlFor="orgtype">
                                Organization Type
                              </label>
                              <select
                                className={`${
                                  editDetails ? "form__input " : "viewMode"
                                } ${!editDetails ? "no-arrow" : ""}`}
                                id="orgtype"
                                value={formData.orgtype}
                                onChange={handleChange}
                                disabled={!editDetails}
                              >
                                {organizationType.map((type) => (
                                  <option key={type.id} value={type.id}>
                                    {type.type}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          {showOtherFieldEdit && (
                            <div>
                              <div
                                className={
                                  errors.othertype
                                    ? "form-group addStyle "
                                    : "form-group addStyle2"
                                }
                              >
                                <label
                                  className="form__labels"
                                  htmlFor="othertype"
                                >
                                  If Others (specify)
                                </label>
                                <input
                                  className="form__input"
                                  type="text"
                                  id="othertype"
                                  placeholder="Specify other type"
                                  value={formData.othertype}
                                  onChange={handleChange}
                                  disabled={!editDetails}
                                />
                              </div>

                              {/* {errors.othertype && (
                                <span className="error-message">
                                  {errors.othertype}
                                </span>
                              )} */}
                            </div>
                          )}
                          <div>
                            <div
                              className={
                                errors.orgname
                                  ? "form-group addStyle "
                                  : "form-group addStyle2"
                              }
                            >
                              <label className="form__labels" htmlFor="orgname">
                                Organization Name
                              </label>

                              <input
                                className={
                                  editDetails ? "form__input" : "viewMode"
                                }
                                type="text"
                                id="orgname"
                                placeholder="Organization name"
                                value={formData.orgname}
                                onChange={handleChange}
                                disabled={!editDetails}
                              />
                            </div>
                            {errors.orgname && (
                              <span className="error-message">
                                {errors.orgname}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="section">
                          <div>
                            <div
                              className={
                                errors.orgaddress
                                  ? "form-group addtextStyle "
                                  : "form-group addtextStyle2"
                              }
                            >
                              <label
                                className="form__labels"
                                htmlFor="OAddress"
                              >
                                Organization Address
                              </label>
                              <textarea
                                className={
                                  editDetails ? "form__input" : "viewMode"
                                }
                                rows=""
                                cols="32"
                                id="orgaddress"
                                placeholder="Organization Address"
                                value={formData.orgaddress}
                                onChange={handleChange}
                                disabled={!editDetails}
                              />
                            </div>
                            {errors.orgaddress && (
                              <span className="error-message">
                                {errors.orgaddress}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="section2">
                          <div>
                            <div
                              className={
                                editDetails
                                  ? "form-group addStyle2 "
                                  : "form-group addStyle"
                              }
                            >
                              <label className="form__labels" htmlFor="state">
                                State
                              </label>
                              <select
                                className={`${
                                  editDetails ? "form__input " : "viewMode"
                                } ${!editDetails ? "no-arrow" : ""}`}
                                id="state"
                                value={formData.state}
                                onChange={handleChange}
                                disabled={!editDetails}
                              >
                                {stateList.map((state) => (
                                  <option
                                    key={state.stateCode}
                                    value={state.stateCode}
                                  >
                                    {state.stateName}
                                  </option>
                                ))}
                              </select>
                            </div>
                            {errors.state && (
                              <span className="error-message">
                                {errors.state}
                              </span>
                            )}
                          </div>
                          <div>
                            <div
                              className={
                                errors.deptname
                                  ? "form-group addStyle "
                                  : "form-group addStyle2"
                              }
                            >
                              <label
                                className="form__labels"
                                htmlFor="Department"
                              >
                                Ministry/ Department
                              </label>
                              <input
                                className={
                                  editDetails ? "form__input" : "viewMode"
                                }
                                type="text"
                                id="deptname"
                                placeholder="Department"
                                value={formData.deptname}
                                onChange={handleChange}
                                disabled={!editDetails}
                              />
                            </div>
                            {errors.deptname && (
                              <span className="error-message">
                                {errors.deptname}
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="section2">
                          <div>
                            <div
                              className={
                                errors.orghead
                                  ? "form-group addStyle "
                                  : "form-group addStyle2"
                              }
                            >
                              <label className="form__labels" htmlFor="Head">
                                Head of Organization
                              </label>
                              <input
                                className={
                                  editDetails ? "form__input" : "viewMode"
                                }
                                type="text"
                                id="orghead"
                                placeholder="Head of Organization"
                                value={formData.orghead}
                                onChange={handleChange}
                                disabled={!editDetails}
                              />
                            </div>
                            {errors.orghead && (
                              <span className="error-message">
                                {errors.orghead}
                              </span>
                            )}
                          </div>
                          <div>
                            <div
                              className={
                                errors.phoneno
                                  ? "form-group addStyle "
                                  : "form-group addStyle2"
                              }
                            >
                              <label className="form__labels" htmlFor="phone">
                                Office Phone No
                              </label>
                              <input
                                className={
                                  editDetails ? "form__input" : "viewMode"
                                }
                                type="text"
                                id="phoneno"
                                placeholder="Phone No"
                                value={formData.phoneno}
                                onChange={handleChange}
                                disabled={!editDetails}
                              />
                            </div>
                            {errors.phoneno && (
                              <span className="error-message">
                                {errors.phoneno}
                              </span>
                            )}
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </CardWrapper>
                <CardWrapper
                  className={editDetails ? "boxDesgn mt" : "boxDesgn1 mt"}
                >
                  <div className="headerWrap ">
                    <MainHeader>Project details</MainHeader>
                  </div>
                  <div className="contentWrap">
                    <form className="form-body">
                      <div className="section">
                        <div>
                          <div
                            className={
                              errors.projectname
                                ? "form-group addStyle "
                                : "form-group addStyle2"
                            }
                          >
                            <label
                              className="form__labels"
                              htmlFor="ProjectName"
                            >
                              Project Name
                            </label>
                            <input
                              className={
                                editDetails ? "form__input" : "viewMode"
                              }
                              type="text"
                              id="projectname"
                              placeholder="Project Name"
                              value={formData.projectname}
                              onChange={handleChange}
                              disabled={!editDetails}
                            />
                          </div>
                          {errors.projectname && (
                            <span className="error-message">
                              {errors.projectname}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="section">
                        <div>
                          <div
                            className={
                              errors.projectdesc
                                ? "form-group addtextStyle "
                                : "form-group addtextStyle2"
                            }
                          >
                            <label
                              className="form__labels"
                              htmlFor="projectdesc"
                            >
                              Brief description of the project
                            </label>
                            <textarea
                              className={
                                editDetails ? "form__input" : "viewMode"
                              }
                              rows="3"
                              cols="32"
                              id="projectdesc"
                              placeholder="Brief Description"
                              value={formData.projectdesc}
                              onChange={handleChange}
                              disabled={!editDetails}
                            />
                          </div>
                          {errors.projectdesc && (
                            <span className="error-message">
                              {errors.projectdesc}
                            </span>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                </CardWrapper>
                <br></br>
                <CardWrapper className={editDetails ? "boxDesgn" : "boxDesgn1"}>
                  <div className="firstSection">
                    <div className="headerWrap ">
                      <MainHeader>Software Development Agency</MainHeader>
                    </div>
                    <div className="contentWrap">
                      <form className="form-body">
                        <div
                          className={
                            showOtherAgencyEdit ? "section2" : "section"
                          }
                        >
                          <div>
                            <div
                              className={
                                editDetails
                                  ? "form-group addStyle2 "
                                  : "form-group addStyle"
                              }
                            >
                              <label
                                className="form__labels"
                                htmlFor="agencyType"
                              >
                                Agency Type
                              </label>
                              <select
                                className={`${
                                  editDetails ? "form__input " : "viewMode"
                                } ${!editDetails ? "no-arrow" : ""}`}
                                id="agencyType"
                                value={formData.agencyType}
                                onChange={handleChangeAgency}
                                disabled={!editDetails}
                              >
                                {agency.map((type) => (
                                  <option value={type.value}>
                                    {type.text}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          {showOtherAgencyEdit && (
                            <div>
                              <div
                                className={
                                  errors.othertype
                                    ? "form-group addStyle "
                                    : "form-group addStyle2"
                                }
                              >
                                <label
                                  className="form__labels"
                                  htmlFor="otheragency"
                                >
                                  If Others (specify)
                                </label>
                                <input
                                  className="form__input"
                                  type="text"
                                  id="otheragency"
                                  placeholder="Specify Other Agency Name"
                                  onChange={handleChange}
                                  value={formData.otheragency}
                                  disabled={!editDetails}
                                />
                              </div>

                              {/* {errors.othertype && (
                                <span className="error-message">
                                  {errors.othertype}
                                </span>
                              )} */}
                            </div>
                          )}
                        </div>
                        {showNICDetails && (
                          <>
                            <div className="section2">
                              <div>
                                <div
                                  className={
                                    editDetails
                                      ? "form-group addStyle2 "
                                      : "form-group addStyle"
                                  }
                                >
                                  <label
                                    className="form__labels"
                                    htmlFor="niccontactname"
                                  >
                                    NIC Contact Name
                                  </label>
                                  <input
                                    className={
                                      editDetails ? "form__input" : "viewMode"
                                    }
                                    type="text"
                                    id="niccontactname"
                                    placeholder="Name"
                                    onChange={handleChange}
                                    value={formData.niccontactname}
                                    disabled={!editDetails}
                                  />
                                </div>
                                {errors.niccontactname && (
                                  <span className="error-message">
                                    {errors.niccontactname}
                                  </span>
                                )}
                              </div>
                              <div>
                                <div
                                  className={
                                    errors.niccontactno
                                      ? "form-group addStyle "
                                      : "form-group addStyle2"
                                  }
                                >
                                  <label
                                    className="form__labels"
                                    htmlFor="niccontactno"
                                  >
                                    NIC Contact Person Phone
                                  </label>
                                  <input
                                    className={
                                      editDetails ? "form__input" : "viewMode"
                                    }
                                    type="text"
                                    id="niccontactno"
                                    placeholder="Contact No"
                                    onChange={handleChange}
                                    value={formData.niccontactno}
                                    disabled={!editDetails}
                                  />
                                </div>
                                {errors.niccontactno && (
                                  <span className="error-message">
                                    {errors.niccontactno}
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="section2">
                              <div>
                                <div
                                  className={
                                    errors.niccontactemail
                                      ? "form-group addStyle "
                                      : "form-group addStyle2"
                                  }
                                >
                                  <label
                                    className="form__labels"
                                    htmlFor="niccontactemail"
                                  >
                                    NIC Contact Person Mail
                                  </label>
                                  <input
                                    className={
                                      editDetails ? "form__input" : "viewMode"
                                    }
                                    type="email"
                                    id="niccontactemail"
                                    placeholder="Mail"
                                    onChange={handleChange}
                                    value={formData.niccontactemail}
                                    disabled={!editDetails}
                                  />
                                </div>
                                {errors.niccontactemail && (
                                  <span className="error-message">
                                    {errors.niccontactemail}
                                  </span>
                                )}
                              </div>
                              <div>
                                <div
                                  className={
                                    errors.niccontactdesg
                                      ? "form-group addStyle "
                                      : "form-group addStyle2"
                                  }
                                >
                                  <label
                                    className="form__labels"
                                    htmlFor="niccontactdesg"
                                  >
                                    NIC Contact Peson Designation
                                  </label>
                                  <input
                                    className={
                                      editDetails ? "form__input" : "viewMode"
                                    }
                                    type="text"
                                    id="niccontactdesg"
                                    placeholder="Designation"
                                    onChange={handleChange}
                                    value={formData.niccontactdesg}
                                    disabled={!editDetails}
                                  />
                                </div>
                                {errors.niccontactdesg && (
                                  <span className="error-message">
                                    {errors.niccontactdesg}
                                  </span>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                      </form>
                    </div>
                  </div>
                </CardWrapper>

                <CardWrapper
                  className={editDetails ? "boxDesgn mt" : "boxDesgn1 mt"}
                >
                  <div className="headerWrap ">
                    <MainHeader>Nodal officer details</MainHeader>
                  </div>
                  <div className="contentWrap">
                    <form className="form-body">
                      <div className="section2">
                        <div>
                          <div
                            className={
                              errors.nodalofficer
                                ? "form-group addStyle "
                                : "form-group addStyle2"
                            }
                          >
                            <label
                              className="form__labels"
                              htmlFor="nodalofficer"
                            >
                              Name
                            </label>
                            <input
                              className={
                                editDetails ? "form__input" : "viewMode"
                              }
                              type="text"
                              id="nodalofficer"
                              placeholder="Name"
                              value={formData.nodalofficer}
                              onChange={handleChange}
                              disabled={!editDetails}
                            />
                          </div>
                          {errors.nodalofficer && (
                            <span className="error-message">
                              {errors.nodalofficer}
                            </span>
                          )}
                        </div>
                        <div>
                          <div
                            className={
                              errors.nodaldesignation
                                ? "form-group addStyle "
                                : "form-group addStyle2"
                            }
                          >
                            <label
                              className="form__labels"
                              htmlFor="nodaldesignation"
                            >
                              Designation
                            </label>
                            <input
                              className={
                                editDetails ? "form__input" : "viewMode"
                              }
                              type="text"
                              id="nodaldesignation"
                              placeholder="Designation"
                              value={formData.nodaldesignation}
                              onChange={handleChange}
                              disabled={!editDetails}
                            />
                          </div>
                          {errors.nodaldesignation && (
                            <span className="error-message">
                              {errors.nodaldesignation}
                            </span>
                          )}
                        </div>
                        <div>
                          <div
                            className={
                              errors.mobileno
                                ? "form-group addStyle "
                                : "form-group addStyle2"
                            }
                          >
                            <label className="form__labels" htmlFor="mob">
                              Contact Number
                            </label>
                            <input
                              className={
                                editDetails ? "form__input" : "viewMode"
                              }
                              type="text"
                              id="mobileno"
                              placeholder="Contact Number"
                              value={formData.mobileno}
                              onChange={handleChange}
                              disabled={!editDetails}
                            />
                          </div>
                          {errors.mobileno && (
                            <span className="error-message">
                              {errors.mobileno}
                            </span>
                          )}
                        </div>
                        <div>
                          <div
                            className={
                              errors.email
                                ? "form-group addStyle "
                                : "form-group addStyle2"
                            }
                          >
                            <label className="form__labels" htmlFor="email">
                              Email
                            </label>
                            <input
                              className={
                                editDetails ? "form__input" : "viewMode"
                              }
                              type="email"
                              id="email"
                              placeholder="Email"
                              value={formData.email}
                              onChange={handleChange}
                              disabled={!editDetails}
                            />
                          </div>
                          {errors.email && (
                            <span className="error-message">
                              {errors.email}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="section">
                        <div
                          className={
                            editDetails
                              ? "form-group fieStyle2 "
                              : "form-group fieStyle"
                          }
                        >
                          <label className="form__labels" htmlFor="upload">
                            Signed copy of Terms of Usage (ToU) for NICDSign
                          </label>
                          <div className="uploadFileD">
                            <div
                              className={
                                editDetails
                                  ? "file-name fileheight"
                                  : "file-name fileheight2"
                              }
                            >
                              {selectedFile?.name}
                            </div>
                            <input
                              className={
                                editDetails
                                  ? "form__input"
                                  : "viewMode fileInput"
                              }
                              type="file"
                              id="upload"
                              onChange={handleLatestUploadFile}
                              accept=".PDF,.pdf"
                              disabled={!editDetails}
                            />
                            <button
                              className={
                                !latestUpload ? "disableBtn" : "Uploadbtn"
                              }
                              onClick={handleUploadLatestFileSubmission}
                              disabled={!latestUpload}
                            >
                              Upload
                            </button>
                            {fileuploadStatus && (
                              <div className="status-msg">
                                {fileuploadStatus}
                              </div>
                            )}
                            {fileuploadErrorStatus && (
                              <div className="error-message">
                                {fileuploadErrorStatus}
                              </div>
                            )}
                          </div>
                        </div>
                        {/* <div
                          className={
                            editDetails
                              ? "form-group fieStyle2 "
                              : "form-group fieStyle"
                          }
                        >
                          <label className="form__labels" htmlFor="captcha">
                            Captcha
                          </label>
                          <img
                            src={realCaptcha}
                            alt="Captchaimage"
                            className="styleImg"
                          />

                          <input
                            className={
                              editDetails ? "form__input " : "viewMode "
                            }
                            type="text"
                            id="captcha"
                            placeholder="Enter Captcha"
                            value={formData.captcha}
                            onChange={handleChange}
                            disabled={!editDetails}
                          />
                        </div> */}
                      </div>
                      <div className="section4">
                        <div
                          className={
                            editDetails
                              ? "form-group fieStyle2 "
                              : "form-group fieStyle"
                          }
                        >
                          <label className="form__labels" htmlFor="captcha">
                            View of uploaded file
                          </label>
                          <PdfViewer pdfData={pdfData} />
                        </div>
                      </div>
                    </form>
                  </div>
                </CardWrapper>
                {/* </form> */}
              </>
            ) : (
              <ViewWrapper id="detailMainWrapper">
                <div className="viewHeading">Organization details</div>
                <div className="viewContents">
                  <div class="viewContent">
                    Organization Type <span>:</span>{" "}
                    <span>{getOrgTypeState(formData.orgtype, "orgtype")}</span>
                  </div>
                  {showOtherFieldEdit && (
                    <div class="viewContent">
                      If Others (specify) <span>:</span>{" "}
                      <span>{formData.othertype}</span>
                    </div>
                  )}
                  <div class="viewContent">
                    Organization Name <span>:</span>{" "}
                    <span>{formData.orgname}</span>
                  </div>
                  <div class="viewContent">
                    Organization Address<span>:</span>{" "}
                    <span className="addSpan">{formData.orgaddress}</span>
                  </div>
                  <div class="viewContent">
                    State <span>:</span>{" "}
                    <span>{getOrgTypeState(formData.state, "state")}</span>
                  </div>
                  <div class="viewContent">
                    Ministry/ Department<span>:</span>{" "}
                    <span>{formData.deptname}</span>
                  </div>

                  <div class="viewContent">
                    Head of Organization <span>:</span>{" "}
                    <span>{formData.orghead}</span>
                  </div>
                  <div class="viewContent">
                    Office Phone No <span>:</span>{" "}
                    <span>{formData.phoneno}</span>
                  </div>
                </div>
                <div className="viewHeading">Project details</div>
                <div className="viewContents">
                  <div class="viewContent">
                    Project Name <span>:</span>{" "}
                    <span>{formData.projectname}</span>
                  </div>
                  <div class="viewContent">
                    Brief description of the project <span>:</span>
                    <span className="addSpan">{formData.projectdesc}</span>
                  </div>
                </div>

                <div className="viewHeading">Software Development Agency</div>
                <div className="viewContents">
                  <div class="viewContent">
                    Agency type <span>:</span>{" "}
                    <span>
                      {formData.agencyType == "O"
                        ? "Others"
                        : formData.agencyType == "N"
                        ? "NIC"
                        : "Inchoice"}
                    </span>
                  </div>
                  {formData.agencyType == "O" && (
                    <div class="viewContent">
                      Other Agency Name <span>:</span>
                      <span className="addSpan">{formData.otheragency}</span>
                    </div>
                  )}

                  {formData.agencyType == "N" && (
                    <>
                      <div class="viewContent">
                        NIC Contact Person Name <span>:</span>
                        <span className="addSpan">
                          {formData.niccontactname}
                        </span>
                      </div>
                      <div class="viewContent">
                        NIC Contact Person Mobile <span>:</span>
                        <span className="addSpan">{formData.niccontactno}</span>
                      </div>
                      <div class="viewContent">
                        NIC Contact Person Email <span>:</span>
                        <span className="addSpan">
                          {formData.niccontactemail}
                        </span>
                      </div>
                      <div class="viewContent">
                        NIC Contact Person Designation<span>:</span>
                        <span className="addSpan">
                          {formData.niccontactdesg}
                        </span>
                      </div>
                    </>
                  )}
                </div>

                <div className="viewHeading">Nodal officer details</div>
                <div className="viewContents">
                  <div class="viewContent">
                    Name <span>:</span> <span>{formData.nodalofficer}</span>
                  </div>
                  <div class="viewContent">
                    Designation <span>:</span>{" "}
                    <span>{formData.nodaldesignation}</span>
                  </div>
                  <div class="viewContent">
                    Contact Number<span>:</span>{" "}
                    <span>{formData.mobileno}</span>
                  </div>
                  <div class="viewContent">
                    Email <span>:</span> <span>{formData.email}</span>
                  </div>
                  <div class="viewContent ">
                    Signed copy of Terms of Usage (ToU) for NICDSign{" "}
                    <span>:</span>
                    <span className="fileStyle"></span>
                  </div>
                  {/* <div class="viewContent">
                    Captcha <span>:</span> <span>{formData.captcha}</span>
                  </div> */}
                </div>
                <div class="viewHeading">Uploaded File View</div>
                <div className="viewContents">
                  <PdfViewer pdfData={pdfData} />
                </div>
              </ViewWrapper>
            )}
          </div>
        </div>
      </MainWrapper>
    </Fragment>
  );
}

export default EditViewPage;
const MainWrapper = styled.div`
  /* position: absolute; */
  width: 100%;
  /* top: 140px; */
  height: auto;
  padding: 10px 25px;
  .error-message {
    color: red;
    font-size: 12px;
    margin-top: 5px;
    margin-left: 4px;
  }
  .viewGrid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 1px 30px;
    justify-items: stretch;
  }
  .editSave {
    display: grid;
    grid-template-columns: auto auto;
    .editInnerWrap {
      display: flex;
      justify-content: end;
      gap: 5px;
    }
  }
  .boxDesgn1 {
    box-shadow: 0 12px 12px rgba(0, 0, 0, 0.1);
  }
  .boxDesgn {
    border: 1px solid #cec7c7;
    background: rgb(242, 243, 249);
  }
  .form__labels {
    font-family: lato;
    color: rgb(113, 113, 113);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 13px;
  }
  .form__input {
    padding: 0px !important;
    border: none !important;
    color: #000;
    width: 100%;
    font-weight: 600;
  }
  .no-arrow {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background: transparent;
    border: none;
    pointer-events: none;
  }

  .no-arrow::-ms-expand {
    display: none;
  }
  textarea {
    resize: none;
  }
  .mt {
    margin-top: 15px;
  }
  .addStyle {
    background: #fff;
    padding: 3px 10px;
    width: 100%;
    border-radius: 10px;
    /* margin: 0px; */
    margin: 12px 0px 0px 0px;
    height: 60px;
    align-self: flex-end;
    border: 1px solid red !important;
  }
  .addtextStyle {
    background: #fff;
    padding: 3px 10px;
    width: 100%;
    border-radius: 10px;
    margin: 0px;
    /* margin: 12px 0px; */
    margin: 12px 0px 0px 0px;
    max-height: 100px;
    min-height: 100px;
    align-self: flex-end;
    border: 1px solid red !important;
    .form__input {
      max-height: 60px;
    }
  }
  .fieStyle {
    background: rgb(242, 243, 249);
    padding: 3px 10px;
    width: 100%;
    border-radius: 10px;
    margin: 12px 0px;
    height: auto;
    align-self: flex-end;
    border: 1px solid rgb(242, 243, 249) !important;
  }
  .fieStyle2 {
    background: #fff;
    padding: 3px 10px;
    width: 100%;
    border-radius: 10px;
    margin: 12px 0px;
    height: auto;
    align-self: flex-end;
    border: 1px solid rgb(188, 188, 188) !important;
    overflow: auto;
  }
  .addStyle2 {
    background: #fff;
    padding: 3px 10px;
    width: 100%;
    border-radius: 10px;
    /* margin: 0px; */
    margin: 12px 0px 0px 0px;
    height: 60px;
    align-self: flex-end;
    border: 1px solid rgb(188, 188, 188) !important;
  }
  .addtextStyle2 {
    background: #fff;
    padding: 3px 10px;
    width: 100%;
    border-radius: 10px;
    margin: 0px;
    /* margin: 12px 0px; */
    margin: 12px 0px 0px 0px;
    max-height: 100px;
    min-height: 100px;
    align-self: flex-end;
    border: 1px solid rgb(188, 188, 188) !important;
    .form__input {
      max-height: 60px;
    }
  }
  .fileheight2 {
    min-height: 82px;
  }
  .fileheight {
    min-height: 47px;
  }
  @media only screen and (min-width: 300px) and (max-width: 700px) {
    .section3 {
      grid-template-columns: 1fr !important;
    }
    .section1 {
      grid-template-columns: 1fr !important;
    }
    .section2 {
      grid-template-columns: 1fr !important;
    }
  }
`;
const CardWrapper = styled.div`
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  /* box-shadow: 0 12px 12px rgba(0, 0, 0, 0.1); */
  .headerWrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .contentWrap {
    padding-top: 15px;
  }
  .viewMode {
    border: none;
    padding: 0px;
    background: transparent;
  }
  input:disabled {
    color: #000 !important;
    font-weight: 600;
  }
  select:disabled {
    color: #000 !important;
    font-weight: 600;
  }
  textarea:disabled {
    color: #000 !important;
    /* max-height: 25px; */
    font-weight: 600;
    height: 108px;
    width: 100%;
  }
  textarea:focus-visible {
    outline: none;
  }
  .editSave {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
  }
  .selectStyle {
    min-height: 40px !important;
  }
  .section {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.5rem 1rem;
    padding-bottom: 6px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .section3 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem 1rem;
    padding-bottom: 6px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .section1 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 0.5rem 1rem;
    padding-left: 20px;
    padding-right: 20px;
  }
  .section2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem 1rem;
    padding-left: 20px;
    padding-right: 20px;
  }
  .section4 {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.5rem 1rem;
    padding-left: 20px;
    padding-right: 20px;
  }
  .file-name {
    color: #4576ef;
    font-weight: 600;
  }
  .fileInput {
    display: none;
  }
  .disableBtn {
    background-color: #aaa8a8;
    /* padding: 13px 10px; */
    border: none;
    border-radius: 5px;
    color: #fff;

    transition: 0.5s all;

    padding: 0px;
    margin: 5px;
    font-size: 14px;
    &:hover {
      cursor: not-allowed;
    }
  }
`;
const MainHeader = styled.div`
  color: #000;
  font-size: 16px;
  font-weight: 600;
`;
const EditBtn = styled.div`
  padding: 2px 15px;
  border: 1px solid #cec7c7;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 14px;
  transition: 0.5s all;
  &:hover {
    cursor: pointer;
    background-color: #0505b1cf;
    color: #fff;
    /* border: none; */
    border: 1px solid #fff;
    img {
      filter: invert(1) brightness(8.5);
    }
  }
  img {
    width: 14px;
  }
`;
const SaveBtn = styled.div`
  padding: 2px 15px;
  /* border: 1px solid #cec7c7;/ */
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 14px;
  transition: 0.5s all;
  background-color: #3c76e6;
  color: #fff;
  &:hover {
    cursor: pointer;
    background-color: #0505b1cf;
    /* color: #fff; */
  }
`;
const CancelBtn = styled.div`
  background: #c3c1c1;
  padding: 2px 15px;
  /* border: 1px solid #cec7c7; */
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 14px;
  transition: 0.5s all;
  &:hover {
    cursor: pointer;
  }
`;
const ViewWrapper = styled.div`
  background: rgb(242, 243, 249);
  border-radius: 10px;
  padding: 15px;
  margin: 10px 0px;
  border: 1px solid rgba(58, 58, 58, 0);
  color: rgb(0, 0, 0);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  .addSpan {
    overflow: auto;
    overflow-wrap: anywhere;
    white-space: pre-wrap;
  }
  .viewHeading {
    border-bottom: 1px solid;
    padding-bottom: 5px;
    display: inline-block;
    font-weight: 800;
    font-size: 14px;
  }
  .viewContent {
    padding: 10px 0px;
    font-size: 14px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 60px;
    display: grid;

    grid-template-columns: 1fr 10% 1fr 1fr;
    justify-content: flex-start;
  }
  .viewContents {
    padding: 10px 0px;
    font-size: 14px;
  }
  .fileStyle {
    color: blue;
    text-decoration: underline;
  }
`;
